import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e864205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-inputgroup p-col-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" })
], -1))
const _hoisted_3 = { class: "p-inputgroup p-col-12 p-my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" })
], -1))
const _hoisted_5 = { class: "p-d-flex p-justify-end p-align-center p-col-12" }
const _hoisted_6 = { class: "p-ml-2" }
const _hoisted_7 = { class: "p-d-flex p-jc-around p-ai-baseline p-col-12" }
const _hoisted_8 = {
  class: "p-d-flex p-jc-between p-ai-center",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("signIn.welcome")), 1),
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      class: "p-p-lg-5 p-grid"
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            class: "p-col-12",
            mode: "indeterminate",
            style: {"height":"0.5em"}
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.input.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.email) = $event)),
          placeholder: _ctx.$t('signIn.email')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.email.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          type: _ctx.passwordType,
          modelValue: _ctx.input.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.password) = $event)),
          placeholder: _ctx.$t('signIn.password')
        }, null, 8, ["type", "modelValue", "placeholder"]),
        _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hidePassword = !_ctx.hidePassword)),
          style: {"cursor":"pointer"},
          class: "p-inputgroup-addon"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(`pi pi-eye${_ctx.hidePassword ? '-slash' : ''}`)
          }, null, 2)
        ])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.password.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.stayConnected,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stayConnected) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("signIn.stayConnected")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          icon: "pi pi-send",
          label: _ctx.$t('signIn.connect'),
          class: "p-button-outlined p-button-rounded",
          "icon-pos": "right",
          type: "submit"
        }, null, 8, ["label"]),
        _createVNode(_component_router_link, {
          to: `${_ctx.accountBaseUrl}/forgot-password`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("signIn.forgot")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 32),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialog.show,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog.show) = $event)),
      breakpoints: { '960px': '75vw' },
      style: { width: '350px', background: 'red' },
      closable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t("signIn.chooseActivity")) + " ", 1),
          _createVNode(_component_Button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialog.show = false)),
            icon: "pi pi-times",
            class: "p-button-text p-button-danger p-button-rounded"
          })
        ])
      ]),
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(_component_Menu, {
          model: _ctx.dialog.activities,
          style: {"width":"100%","padding-bottom":"15px"}
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}